import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Navigation /* , { NavigationLine } */ from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import { purdyPagesMenu } from '../../../menu';
import ThemeContext from '../../../contexts/themeContext';

import useDarkMode from '../../../hooks/useDarkMode';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';
import CisBrand from './PurdyBrand';

const PurdyAside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);

	const { t } = useTranslation(['translation', 'menu']);

	const { darkModeStatus } = useDarkMode();

	return (
		<Aside>
			<AsideHead>
				<CisBrand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>
			<AsideBody>
				<Navigation menu={purdyPagesMenu} id='aside-dashboard' />
				{/* <NavigationLine /> */}
			</AsideBody>
			<AsideFoot>
				<User />
			</AsideFoot>
		</Aside>
	);
};

export default PurdyAside;
